import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { boot } from '@lmac/ui';
import { App } from './App';
import { reportHeightToParent } from './embedHeight';
import './styles.css';

boot('root', (el) => {
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  reportHeightToParent();
});
